const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';


//Import Designs
import {
    Typography,
    Grid2,
    Card,
    CardContent,
    CardActions,
    Button,
    Link,
    Divider,
    Dialog,
    DialogActions,
    DialogTitle,
    Slide,
    Backdrop,
    CircularProgress,
} from '@mui/material';

//Action to save and fetch data
import { fetchauthorallprofile, frontimmute, frontsingleimmute, deleteContestant, fetcheditpost } from '../../actions/front_actions';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FavoriteIcon from "@mui/icons-material/Favorite";
import CategoryIcon from '@mui/icons-material/Category';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ShareIcon from '@mui/icons-material/Share';

import ContestantTitle from './ContestantTitle.jsx';
import ContestantImage from './ContestantImage.jsx';
import VideoContestant from './VideoContestant.jsx';
import ContestantSocial from './ContestantSocial.jsx';
import Updateform from './Updateform.jsx';
import Paginationcontestants from './Paginationcontestants.jsx';
import CriticalError from '../CriticalError.jsx';
import dateFormat from 'dateformat';

class ProfileScreen extends Component {
    constructor(props) {
        super(props);
        this.state = { anchorEl: '', modalopen: 0, wait: 1, single_post: null, edit_val: null, delete_val: null, page_number: 1 };
        this.contestantsContainer = React.createRef();
    }

    componentDidMount = () => {
        this.setState({ wait: 1 });
        let pagin_val = 1;
        if (this.props.paginate_value != '') {
            pagin_val = this.props.paginate_value;
        }
        this.props.fetchauthorallprofile(this.props.SITE_URL, this.props.short, pagin_val);
        setTimeout(function () {
            this.setState({ wait: 0 });
        }.bind(this), 1000);
    }

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.deleted !== "undefined") {
            if (nextProps.deleted == this.state.delete_val) {
                //Deleted Success
                this.setState({ delete_val: null });
                this.props.fetchauthorallprofile(this.props.SITE_URL, this.props.short);
            }
        }
    }

    pagination = (event, value) => {
        if (!Number.isInteger(value)) {
            value = event.target.value;
        }
        this.props.frontimmute('paginate_value', value);
        this.setState({ wait: 1 });
        this.props.fetchauthorallprofile(this.props.SITE_URL, this.props.short, value, "");
        this.setState({ wait: 0, page_number: value });
        this.contestantsContainer.current.scrollIntoView({ behavior: 'smooth' });
    }

    paginationbtn = (btn, value) => {
        if (btn == 'button') {
            value = value + 1;
        }
        this.setState({ wait: 0 });
        this.props.fetchauthorallprofile(this.props.SITE_URL, this.props.short, value, "load");
        this.setState({ wait: 0, page_number: value });
    }

    handleDeleteContestant = () => {
        this.setState({ wait: 1 });
        this.props.deleteContestant(this.props.SITE_URL, this.state.delete_val);
        this.setState({ wait: 0, modalopen: 0 });
        alert('Contestant Deleted Successfully!');
        window.location.reload();
    }

    getformatteddate(date_val) {
        if (date_val != null) {
            // var dateFormat = require("dateformat");
            var start_Date = dateFormat(date_val, "mmm dd yyyy");
            return start_Date;
        }
    }

    handleEditval = (term_id, post_id, singlepost) => {
        this.props.fetcheditpost(this.props.SITE_URL, term_id, post_id);
        this.setState({ edit_val: post_id, single_post: singlepost });
        window.scrollTo(0, 0);
    }

    handleDelete = (post_id) => {
        this.setState({ delete_val: post_id, modalopen: 1 });
    }

    handleClose = () => {
        this.setState({ modalopen: 0 });
    }


    //Immutable functions
    handleValueChange = externalId => (event) => {
        this.props.frontsingleimmute(externalId, event.target.name, event.target.value);
    }

    handleFileChange = externalId => (event) => {
        let file = event.target.files[0];
        this.props.frontsingleimmute(externalId, event.target.name, file);
    }

    handleValueDate = externalId => (event) => {
        const find_editor = externalId.split('--');
        const arlength = find_editor.length;
        if (arlength >= 1) {
            const value = event;
            this.props.frontsingleimmute(find_editor[0], find_editor[1], value);
        }
    }

    handleValueCheckbox = externalId => (event, isChecked) => {
        let name = event.target.name;
        let get_previous_val = this.props.model.contestant_form[name];
        if (isChecked) {
            if (get_previous_val == '') {
                this.props.frontsingleimmute(externalId, event.target.name, event.target.value);
            } else {
                let add_val = get_previous_val + "," + event.target.value;
                this.props.frontsingleimmute(externalId, event.target.name, add_val);
            }
        } else {
            if (get_previous_val != '') {
                let new_string = get_previous_val.replace(',' + event.target.value, '');
                let new_string_val = new_string.replace(event.target.value + ',', '');
                let new_string_vl = new_string_val.replace(event.target.value, '');
                this.props.frontsingleimmute(externalId, event.target.name, new_string_vl);
            }
        }
    }

    handleValueEditor = externalId => (event) => {
        let editor_val = (event.srcElement === undefined) ? event : event.srcElement.innerHTML;
        this.props.frontsingleimmute('contestant_form', externalId, editor_val);
    }

    calculateVoteTimeLeft(date_time) {
        let current_date = this.props.currentdate;
        if (!current_date) {
            current_date = new Date();
        }
        if (date_time != null) {
            date_time = date_time.replace(/ /g, "T");
            // var dateFormat = require("dateformat");
            var start_Date = dateFormat(date_time);
            let difference = new Date(start_Date) - current_date;
            return difference;
        } else {
            return -1;
        }
    }

    render() {
        const { t } = this.props;
        const posts = (typeof this.props.post.posts !== "undefined") ? this.props.post.posts : null;
        const allprops = this.props;
        const { votes_button_bgcolor, votes_button_font_color } = this.props.settings.color;

        const Transition = React.forwardRef(function Transition(props, ref) {
            return <Slide direction="up" ref={ref} {...props} />;
        });

        let user_id = (allprops.short.user_id_profile) ? allprops.short.user_id_profile : 0;
        if (this.props.criticalError !== undefined) {
            return <CriticalError msg={this.props.criticalError} />
        }
        if ((posts != null && typeof posts === 'object') && user_id != 0 && (this.state.wait != 1) && (posts.length > 0)) {
            return (
                (<Grid2 container className="wpvc_profile_screen_container" ref={this.contestantsContainer}>
                    {this.state.edit_val != null &&
                        <Updateform
                            {...allprops}
                            profilescreen="1"
                            singlepost={this.state.single_post}
                            short={this.props.short}
                            SITE_URL={this.props.SITE_URL}
                            ORIGINAL_URL={this.props.ORIGINAL_URL}
                            valchange={this.handleValueChange}
                            filechange={this.handleFileChange}
                            ediorchange={this.handleValueEditor}
                            checkboxchange={this.handleValueCheckbox}
                            datepickerchange={this.handleValueDate}
                            edit_value={this.state.edit_val}
                        />
                    }
                    <Grid2 container size={12} direction="row" spacing={3} className="wpvc_show_style">
                        {posts.map((object, i) => {
                            // const short = allprops.taxonomy.filter((tax) => tax.term_id == object.allcatoption.term_id)[0];

                            let end_time = object.allcatoption.votes_expiration;
                            let start_time = object.allcatoption.votes_starttime;
                            let timer = null;
                            let showform = 0;

                            let total_posts = object.allcatoption.published_post_count;
                            let tax_activationcount = object.allcatoption.tax_activationcount || 0;

                            if (!start_time) {
                                showform = 1;
                                if (tax_activationcount !== 0 && parseInt(tax_activationcount) <= parseInt(total_posts)) {
                                    showform = 0;
                                }
                            } else if (start_time) {
                                showform = this.calculateVoteTimeLeft(start_time);
                                if (tax_activationcount !== 0 && parseInt(tax_activationcount) <= parseInt(total_posts)) {
                                    showform = 0;
                                }
                            } else if (end_time) {
                                showform = this.calculateVoteTimeLeft(end_time);
                            }

                            if (end_time) {
                                timer = this.calculateVoteTimeLeft(end_time);
                            }

                            if (tax_activationcount !== 0 && parseInt(tax_activationcount) <= parseInt(total_posts)) {
                                timer = -1;
                            }

                            let show_edit = 'off';
                            if (showform > 0 && ((timer > 0 || timer == null))) {
                                if (typeof object.allcatoption !== "undefined") {
                                    show_edit = object.allcatoption.editenablecontestant;
                                }
                            }
                            return (
                                (<Grid2
                                    key={i}
                                    className="wpvc_show_style_row"
                                    size={{
                                        xs: 12,
                                        md: 4
                                    }}>
                                    <Card className="wpvc_card_row">

                                        {object.img_contest != null && (object.img_contest == "photo" || object.img_contest == "essay") &&
                                            <ContestantImage {...allprops} singlepost={object} indexpost={i} view="topten" />
                                        }
                                        {object.img_contest != null && (object.img_contest == "video" || object.img_contest == "music") &&
                                            <VideoContestant {...allprops} singlepost={object} indexpost={i} all_contest="1" screen="profile_screen" view={this.props.view} />
                                        }

                                        <CardContent className="wpvc_card_content_row wpvc_card_profile_title">
                                            <ContestantTitle {...allprops} singlepost={object} view={this.props.view} />
                                        </CardContent>

                                        <CardActions disableSpacing className="wpvc_cardcontainer_profile">
                                            <Grid2 container
                                                className="wpvc_profile_info_tab"
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="flex-end"
                                                style={{ 'background': votes_button_bgcolor, 'color': votes_button_font_color }}
                                                spacing={4}
                                            >
                                                <Grid2 className="wpvc_profile_date" size={6}>
                                                    <Typography><CalendarTodayIcon /></Typography>
                                                    <Typography>{t("upload_date")}</Typography>
                                                    <Typography className="wpvc_bold_typo">{this.getformatteddate(object.date)}</Typography>
                                                </Grid2>
                                                <Grid2 className="wpvc_profile_category" size={6}>
                                                    <Typography><CategoryIcon /></Typography>
                                                    <Typography>{t("category")}</Typography>
                                                    <Typography className="wpvc_bold_typo">{object.term_name}</Typography>
                                                </Grid2>
                                                <Grid2 className="wpvc_profile_vote" size={6}>
                                                    <Typography><FavoriteIcon /></Typography>
                                                    <Typography>{t("fr_votes")}</Typography>
                                                    <Typography className="wpvc_bold_typo">{object.votes_count}</Typography>
                                                </Grid2>
                                                {(show_edit == 'on') &&
                                                    <Grid2 className="wpvc_profile_edit" size={6}>
                                                        <Typography><AddPhotoAlternateIcon /></Typography>
                                                        <Typography>{t("edit_delete")}</Typography>
                                                        <Typography className="wpvc_edit_delete_typo">
                                                            <Link
                                                                className="wpvc_edit_delete"
                                                                href="#add_contestant"
                                                                onClick={() => this.handleEditval(object.term_id, object.id, object)}
                                                            ><EditIcon /></Link>
                                                            <Link
                                                                className="wpvc_edit_delete"
                                                                href={undefined}
                                                                onClick={() => this.handleDelete(object.id)}
                                                            ><DeleteIcon /></Link>
                                                        </Typography>
                                                    </Grid2>
                                                }
                                                <Grid2 className="wpvc_profile_status" size={6}>
                                                    <Typography><CheckCircleOutlineIcon /></Typography>
                                                    <Typography>{t("post_status")}</Typography>
                                                    <Typography className="wpvc_bold_typo wpvc_status_post">{object.status}</Typography>
                                                </Grid2>
                                                <Grid2 className="wpvc_profile_share" size={6}>
                                                    <Typography><ShareIcon /></Typography>
                                                    <Typography className="wpvc_profile_share_contest">{t("social")}</Typography>
                                                    <ContestantSocial {...allprops} singlepost={object} view="grid" />
                                                </Grid2>


                                            </Grid2>
                                        </CardActions>

                                    </Card>
                                </Grid2>)
                            );
                        }
                        )}
                        <Paginationcontestants
                            {...allprops}
                            pagenumber={this.state.page_number}
                            changepagin={this.pagination}
                            changepaginbtn={this.paginationbtn}
                            select_value={this.props.paginate_value}
                        />
                    </Grid2>
                    {this.state.modalopen == 1 &&
                        <Dialog
                            open={this.state.modalopen}
                            TransitionComponent={Transition}
                            onClose={this.handleClose}
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                            className="wpvc_profile_delete_dailog"
                        >
                            <DialogTitle id="alert-dialog-slide-title">{t("do_you_wanna_delete")}</DialogTitle>
                            <DialogActions>
                                <Button onClick={this.handleClose} color="secondary">
                                    {t('cancel')}
                                </Button>
                                <Button onClick={this.handleDeleteContestant} color="primary">
                                    {t('delete')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    }
                </Grid2>)
            );
        } else if (user_id == 0) {
            return (
                <Grid2 container className="wpvc_hr_contestants" >
                    <Typography align="center" variant="h6" component="h6">{t("no_contestants_found")}</Typography><Divider variant="middle" />
                </Grid2>
            )
        } else if ((posts != null && typeof posts === 'object') && posts.length == 0) {
            return (
                <Grid2 container className="wpvc_hr_contestants" >
                    <Typography align="center" variant="h6" component="h6">{t("no_contestants_found")}</Typography><Divider variant="middle" />
                </Grid2>
            )
        }
        else if (posts == 'perpage') {
            return '';
        }
        else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }
    }
}
const settingstate = state => {
    return { post: state.wpvcfrontdata };
}

export default connect(settingstate, { deleteContestant, frontsingleimmute, frontimmute, fetchauthorallprofile, fetcheditpost })(withTranslation("translations")(ProfileScreen));
